function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}"));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  width: 24,
  height: 24
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M6.94737,12.84243h3.78947V8.6319H6.94737a.42137.42137,0,0,0-.42105.42106v3.36842A.42136.42136,0,0,0,6.94737,12.84243ZM11.579,13.693v4.62315a.42105.42105,0,0,1-.42106.42106H9.47368a.421.421,0,0,1-.39944-.28791L7.486,13.68454H6.94737a1.26409,1.26409,0,0,1-1.20161-.87272,2.10564,2.10564,0,0,1,0-4.14931A1.26408,1.26408,0,0,1,6.94737,7.7898h4.21052a15.46485,15.46485,0,0,0,5.6331-1.233c.67781-.27113,1.30733-.56167,1.87171-.85192.33685-.17325.57561-.30695.69962-.38135A.421.421,0,0,1,20,5.68454V15.7898a.42105.42105,0,0,1-.63768.361c-.124-.07441-.36277-.20811-.69962-.38135-.56438-.29025-1.1939-.5808-1.87171-.85192A15.97952,15.97952,0,0,0,11.579,13.693Zm-.84211-.00842H8.37365l1.40351,4.21052h.95968ZM5.68421,9.546a1.26351,1.26351,0,0,0,0,2.38233ZM11.579,12.85022a16.74166,16.74166,0,0,1,5.52479,1.28548c.70377.28151,1.35715.58307,1.94409.88492l.11006.057v-8.681l-.11006.057c-.58694.30185-1.24032.60341-1.94409.88492A16.74193,16.74193,0,0,1,11.579,8.62412Z"
});

function SvgAnnounce(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    width: "24px",
    height: 14.316,
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnounce);
export default __webpack_public_path__ + "static/media/announce.7b762811.svg";
export { ForwardRef as ReactComponent };